import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "video-container" }
const _hoisted_2 = ["muted"]
const _hoisted_3 = { class: "icons" }

import {computed, onMounted, onUpdated, ref, watch} from "vue";
import WebRtcMediaStream from "~/ts/library/webRtc/WebRtcMediaStream";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";


const __default__ = {
    name: "WebRtcVideo"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    stream: {},
    muted: { type: Boolean },
    isLocal: { type: Boolean },
    audioEnabled: { type: Boolean },
    videoEnabled: { type: Boolean },
    webRtcMediaStream: {}
  },
  setup(__props: any) {

let props = __props;

let videoElement = ref<HTMLVideoElement>();

async function initVideoElement(force: boolean = false) {
    if (!videoElement.value.playsInline) {
        videoElement.value.playsInline = true;
    }
    if (!videoElement.value.srcObject) {
        videoElement.value.disableRemotePlayback = true;
        addDisposableEvent(props.webRtcMediaStream.connectVideoAndAudioContext(videoElement.value));
    }
    if (force || !videoElement.value.srcObject) {
        videoElement.value.srcObject = props.stream;
    }
}

onMounted(() => {
    watch(computed(() => props.stream), () => {
        initVideoElement(true);
    }, {
        immediate: true
    });
});


onUpdated(() => initVideoElement());



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("video", {
      ref_key: "videoElement",
      ref: videoElement,
      autoplay: "",
      muted: __props.muted,
      key: `${__props.audioEnabled}_${__props.videoEnabled}`,
      playsinline: "",
      pip: "false"
    }, null, 8, _hoisted_2)),
    _createElementVNode("div", _hoisted_3, [
      (!__props.audioEnabled)
        ? _renderSlot(_ctx.$slots, "noaudio", { key: 0 })
        : _createCommentVNode("", true),
      (!__props.videoEnabled)
        ? _renderSlot(_ctx.$slots, "novideo", { key: 1 })
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})